import type { EmotionCache } from "@emotion/react";
import type { AppProps } from "next/app";
import AppCore from "../app-shell/AppCore";
import { AppWithHydrationOverlay } from "../app-shell/AppWithHydrationDevOverlay";

export default function App(props: AppProps & { emotionCache?: EmotionCache }) {
  if (process.env.NODE_ENV === "development") {
    return <AppWithHydrationOverlay {...props} />;
  }

  return <AppCore {...props} />;
}
